import AiSpendBreakdown from '../../../components/AiSpend/AiSpendBreakdown';

export default function AiSpendByProvider() {
  return (
    <AiSpendBreakdown
      dimension="provider"
      title="Provider"
      description="Each provider bills in exactly one unit, so this is the only breakdown where a per-unit cost is meaningful throughout."
    />
  );
}
